import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const CustomerGenderForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerGender}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
